var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.colorAvailable)?_c('SummaryOptions',{attrs:{"totalPrice":_vm.totalPrice},on:{"downloadReceipt":_vm.downloadReceipt},model:{value:(_vm.summaryOptionsAndColor),callback:function ($$v) {_vm.summaryOptionsAndColor=$$v},expression:"summaryOptionsAndColor"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }